import { render, staticRenderFns } from "./ProcessDesign.vue?vue&type=template&id=045da574&scoped=true"
import script from "./ProcessDesign.vue?vue&type=script&lang=js"
export * from "./ProcessDesign.vue?vue&type=script&lang=js"
import style0 from "./ProcessDesign.vue?vue&type=style&index=0&id=045da574&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045da574",
  null
  
)

export default component.exports